function acc() {
	const accs = document.querySelectorAll('.block-content-images__acc');

	if (accs) {
		accs.forEach(acc => {
			const items = acc.querySelectorAll('.block-content-images__acc-title button');

			if (items) {
				function closeOthers(currentItem) {
					items.forEach(item => {
						if (item !== currentItem) {
							item.parentElement.parentElement.classList.remove('active');
						}
					})
				}

				items.forEach(item => {
					item.addEventListener('click', function() {
						closeOthers(item);
						item.parentElement.parentElement.classList.toggle('active');
					});
				});
			}
		});
	}
}

export default acc;